module.exports = __webpack_public_path__ + "img/pattern.f8bf4d9e.png";